import React, { useState } from "react";
import {
  AddFlex,
  CustomCalendarComponent,
  CustomInput,
  CustomText,
  PrimaryActionButton,
  SecondaryActionButton,
} from "../../../reusableStyles";
import useWindowSize from "../../../Hooks/useWindowSize";
import { Dialog } from "@mui/material";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { format } from "date-fns";
import { sortScheduleDetailsAction } from "../../../Store/appTempSlice";
import { useDispatch } from "react-redux";
import moment from "moment-timezone";
import { Calendar, DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";
import { isNullOrUndefined } from "../../../utils";

function FromToDates({
  handleUpdateSchedule,
  scheduleDetail,
  showEndDate,
  timezone,
  months,
}) {
  const { isMobileView } = useWindowSize();
  const [startDateEndDate, setStartDateEndDate] = useState({
    start: scheduleDetail.date,
    endDate: scheduleDetail.endDate,
  });
  // state that tracks which date is the user currently editing. [ start | endDate ]
  const [selectedDateKey, setSelectedDateKey] = useState();

  const dateAsPerSelectedTimezone = (date) => {
    const originDate = moment.tz(
      date.toISOString(),
      Intl.DateTimeFormat().resolvedOptions().timeZone
    );
    const finalDate = moment
      .tz(
        {
          year: originDate.year(),
          month: originDate.month(),
          day: originDate.date(),
        },
        timezone
      )
      .utc()
      .format();
    return finalDate;
  };

  return (
    <>
      <AddFlex
        margin="0 0px 24px 0"
        flexDirection={isMobileView() && "column"}
        gap="10px"
        alignItems="center"
        width="100%"
      >
        <CustomInput
          label={showEndDate ? "From Date" : "Date"}
          value={format(new Date(scheduleDetail.date), "dd MMM yyyy", timezone)}
          widget={<CalendarMonthOutlinedIcon sx={{ color: "grey" }} />}
          // width={isMobileView() ? "100%" : "50%"}
          onClick={() => setSelectedDateKey("start")}
          onChange={() => {
            return;
          }}
        />
        {showEndDate && (
          <CustomInput
            label={"To Date"}
            value={
              scheduleDetail.endDate && //Case where end date is not there Eg: When Initially Created
              format(new Date(scheduleDetail.endDate), "dd MMM yyyy", timezone)
            }
            widget={<CalendarMonthOutlinedIcon sx={{ color: "grey" }} />}
            width={isMobileView() ? "100%" : "50%"}
            onClick={() => {
              setSelectedDateKey("endDate");
            }}
            onChange={() => {
              return;
            }}
          />
        )}
        {!isNullOrUndefined(selectedDateKey) && (
          <div
            style={{
              boxShadow: "0 0 8px 2px rgba(0,0,0,0.25)",
              width: "max-content",
              borderRadius: "4px",
              margin: "0px",
              position: "absolute",
              backgroundColor: "white",
              left: 0,
              top: "120%",
              zIndex: 111111,
            }}
          >
            <Calendar
              date={moment
                .tz(startDateEndDate[selectedDateKey], timezone)
                .format()}
              onChange={(date) => {
                const finalDate = dateAsPerSelectedTimezone(date);
                setStartDateEndDate((prev) => ({
                  ...prev,
                  [selectedDateKey]: finalDate,
                }));
              }}
            />
            <AddFlex padding="10px" gap="10px">
              <SecondaryActionButton
                style={{ flexGrow: 1 }}
                onClick={() => {
                  setSelectedDateKey(null);
                }}
              >
                Cancel
              </SecondaryActionButton>
              <PrimaryActionButton
                onClick={() => {
                  handleUpdateSchedule("date", startDateEndDate.start);
                  handleUpdateSchedule("endDate", startDateEndDate.endDate);
                  setSelectedDateKey(null);
                }}
                style={{ flexGrow: 1 }}
              >
                Done
              </PrimaryActionButton>
            </AddFlex>
          </div>
        )}
      </AddFlex>
    </>
  );
}

export default FromToDates;
